(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["image~index"],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
 // 样式文件
// import './style/index.scss';

var MegImage = {
  name: 'MegImage',
  props: {
    src: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].any,
    fit: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(["fill", "contain", "cover", "none", "scale-down"]).def('fill'),
    loading: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool.def(false)
  },
  data: function data() {
    return {
      status: false
    };
  },
  watch: {
    src: {
      handler: function handler(newVal) {
        this.loadImage();
      },
      immediate: true
    }
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  methods: {
    loadImage: function loadImage() {
      var _this = this;

      var img = new Image();
      img.src = this.src;
      if (this.loading) this.status = 'loading';

      img.onload = function () {
        _this.status = 'normal';
      };

      img.onerror = function () {
        _this.status = 'error';
      };
    },
    click: function click() {},
    mouseOver: function mouseOver() {}
  },
  render: function render() {
    var h = arguments[0];
    var src = this.src,
        fit = this.fit,
        status = this.status;
    var imgNode = null;

    switch (status) {
      case 'normal':
        imgNode = h("img", {
          "class": "meg-image-inner",
          attrs: {
            src: src
          },
          style: 'object-fit:' + fit
        });
        break;

      case 'loading':
        imgNode = h("div", {
          "class": "meg-image-error"
        }, [h("meg-icon", {
          attrs: {
            color: "#1067d1",
            spin: true,
            name: "megui-loading",
            width: "30px",
            height: "30px"
          }
        })]);
        break;

      default:
        imgNode = h("div", {
          "class": "meg-image-error"
        }, [h("meg-icon", {
          attrs: {
            color: "white",
            name: "megui-pic-white",
            width: "30px",
            height: "30px"
          }
        })]);
        break;
    }

    return h("div", {
      "class": "meg-image"
    }, [imgNode]);
  }
};

MegImage.install = function (Vue) {
  Vue.component(MegImage.name, MegImage);
};

/* harmony default export */ __webpack_exports__["default"] = (MegImage);

/***/ })

}]);